import script from "./CallCenterLogin.vue?vue&type=script&setup=true&lang=js"
export * from "./CallCenterLogin.vue?vue&type=script&setup=true&lang=js"

import "./CallCenterLogin.vue?vue&type=style&index=0&id=4381fa7f&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4381fa7f"]])

export default __exports__